import PropTypes from "prop-types";
import React, { useRef } from "react";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { parseSurveyDate } from "../../../utils/SurveyDateUtils";

function isVisible(elem) {
    if (!(elem instanceof Element)) throw Error("DomUtil: elem is not an element.");
    const style = getComputedStyle(elem);
    if (style.display === "none") return false;
    if (style.visibility !== "visible") return false;
    if (style.opacity < 0.1) return false;
    if (
        elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height + elem.getBoundingClientRect().width ===
        0
    ) {
        return false;
    }
    const elemCenter = {
        x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
        y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
    };
    if (elemCenter.x < 0) return false;
    if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
    if (elemCenter.y < 0) return false;
    if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
    let pointContainer = document.elementFromPoint(elemCenter.x, elemCenter.y);
    do {
        if (pointContainer === elem) {
            return true;
        }
        // eslint-disable-next-line no-cond-assign
    } while ((pointContainer = pointContainer.parentNode));
    return false;
}

const DatePickerComponent = ({
                                 value,
                                 onChange,
                                 dateFormat,
                                 displayFormat,
                                 inputProps = {},
                                 name,
                                 disabled
                             }) => {
    const dateType = displayFormat || (
        dateFormat === "Day"
            ? "DD.MM.YYYY"
            : dateFormat === "Month"
                ? "MM/YYYY"
                : dateFormat === "Year"
                    ? "YYYY"
                    : "DD.MM.YYYY");
    const ref = useRef();
    const date = parseSurveyDate(value);

    let updatePositionInterval;
    const updatePosition = () => {
        const wrapper = ref?.current?.parentNode;  
        const picker = wrapper?.getElementsByClassName("rdtPicker")?.[0];
        if (picker) {
            destroyUpdatePosition();
            updatePositionInterval = setInterval(() => {
                if (isVisible(wrapper)) {
                    const wrapperBounds = wrapper.getBoundingClientRect();
                    const left = `${wrapperBounds.left}px`;
                    const top = `${wrapperBounds.top + wrapperBounds.height}px`;
                    picker.style.display = 'fixed';
                    if (picker.style.left !== left) {
                        picker.style.left = left;
                    }
                    if (picker.style.top !== top) {
                        picker.style.top = top;
                    }

                } else {
                    picker.style.display = 'none';
                }
            }, 100);
        }
    };

    const destroyUpdatePosition = () => {
        if (updatePositionInterval) {
            clearInterval(updatePositionInterval);
            updatePositionInterval = null;
        }
    };

    return (
        <DateTime
            utc
            className="daad-datetime"
            timeFormat={false}
            dateFormat={dateType}
            value={displayFormat ? (value || "") : (value ? (date.isValid() ? date.format(dateType) : value) : null)}
            onChange={onChange}          
            strictParsing
            inputProps={{
                ref: ref,
                placeholder: dateType,
                name: name || "",
                disabled,
                ...inputProps
            }}
            onOpen={updatePosition}
            onClose={destroyUpdatePosition}
            closeOnSelect
        />
    );
};

DatePickerComponent.propTypes = {
    dateFormat: PropTypes.string,
    displayFormat: PropTypes.string,
    inputProps: PropTypes.object,
    value: PropTypes.string,
    onChange: PropTypes.func,
    name: PropTypes.string,
    className: PropTypes.string
};

export default DatePickerComponent;
